<template>
    <div class="view-container" @click="closeSelect">
        <loader :loading="loading" v-if="loading"/>
        <div class="container view" v-else>
            <div class="add-container">
                <span class="container-title">Send SMS</span>
                <div class="col-wrapper py-3">
                    <div class="col">
                        <div class="primary-input-container weekdays-from">
                            <p class="pimary-input-title">ANI</p>
                            <div class="searchable-dropdown">
                                <div class="input">
                                    <img @click="showList" src="/img/Down.b9194302.svg" alt class="icon-down"/>
                                    <input
                                            name="ani"
                                            class="search-input"
                                            @input="searchDid"
                                            @click="focusInput"
                                            v-model.trim="modelCompany"
                                            v-validate="{numeric: true}"
                                            :class="{'input': true, 'is-danger': errors.has('ani')}"
                                    />
                                </div>

                                <div class="primary-select-wrapper">
                                    <div v-if="isShow" class="inner-box">
                                        <div
                                                class="item"
                                                v-for="(cmp, idx) in filtered_company_list"
                                                :key="idx"
                                                :data-did="cmp.did"
                                                @click="selectDid"
                                        >{{ cmp.did }}
                                        </div>
                                    </div>
                                    <!-- <select
                                      ref="select"
                                      v-model="company"
                                      name="company"
                                      :class="{'input': true, 'is-danger': errors.has('company')}"
                                    >
                                      <option
                                        v-for="(cmp, idx) in company_list"
                                        :key="idx"
                                        :value="cmp.did"
                                      >{{cmp.did}}</option>
                                    </select>-->
                                </div>
                            </div>
                            <div class="help is-danger"
                                 v-if="errors.has('ani')"
                            >{{ errors.first('ani') }}
                            </div>
                            <div class="help is-danger" v-if="errors.has('company')">{{ errors.first('company') }}</div>
                        </div>

                        <!--                        <el-checkbox v-model="checked">Bulk</el-checkbox>-->

                        <el-radio-group v-model="checked">
                            <el-radio class="ml-0 " label="Bulk"></el-radio>
                            <el-radio class="ml-0 mx-4" label="Import"></el-radio>
                            <el-radio class="ml-0 " label="Single" disabled checked></el-radio>
                        </el-radio-group>

                        <div
                                v-if="checked === 'Import'"
                                class="primary-input-container mt-3"
                                style="margin-bottom: 15px"
                        >
                            <p class="pimary-input-title">Upload CSV Number List</p>

                            <el-radio-group v-model="fileUploadMode">
                                <el-radio class="ml-0 mx-3" label="Single Message"></el-radio>
                                <el-radio class="ml-0 mx-3" label="Varying Message"></el-radio>
                                <el-radio class="ml-0 mx-3" label="Auto Substituting"></el-radio>
                            </el-radio-group>

                            <div v-if="fileUploadMode === 'Auto Substituting'">
                                <div class="row align-items-start my-2">
                                    <div class="col-md-3 col-5 font-weight-bold">Content</div>
                                    <div class="col-md-9 col-7">
                    <textarea
                            @input="getFields"
                            class="form-control"
                            v-model="content"
                            v-validate="'required'"
                            :class="{'input': true, 'is-danger': errors.has('text')}"
                            name="text"
                            placeholder="Enter message content"
                            rows="3"
                    ></textarea>
                                    </div>
                                </div>

                                <div class="row align-items-center my-2">
                                    <div class="col-md-3 col-5 font-weight-bold">Upload Numbers</div>
                                    <div class="col-md-9 col-7">
                                        <input type="file" :key="inputFileKey" @change="uploadNumbersFile" v-validate="'required'"/>
                                    </div>
                                </div>
                                <template v-for="(field_name, idx) in fields_array">
                                    <div class="row align-items-center my-2" :key="idx">
                                        <div class="col-md-3 col-5 font-weight-bold">Upload {{"{"+field_name+"}"}}</div>
                                        <div class="col-md-9 col-7">
                                            <input type="file" @change="e => uploadField(e, field_name)"
                                                   v-validate="'required'"/>
                                        </div>
                                    </div>
                                </template>

                            </div>

                            <div v-if="fileUploadMode !== 'Auto Substituting'">
                                <input
                                        type="file"
                                        v-on:change="onFileChange"
                                        v-validate="'required'"
                                />
                            </div>
                        </div>

                        <div v-else-if="checked === 'Bulk'" class="primary-input-container ">
                            <p class="pimary-input-title">Numbers</p>
                            <div class="text-area-container">
                <textarea
                        v-model="bulk_number"
                        v-if="uploadNumbers.length == 0"
                        v-validate="'required'"
                        :class="{'input': true, 'is-danger': errors.has('bulk_number')}"
                        name="bulk_number"
                        placeholder="Enter numbers"
                        cols="30"
                        rows="10"
                ></textarea>
                                <textarea
                                        v-model="bulk_number"
                                        v-else
                                        :class="{'input': true, 'is-danger': errors.has('bulk_number')}"
                                        name="bulk_number"
                                        placeholder="Enter numbers"
                                        cols="30"
                                        rows="10"
                                ></textarea>
                            </div>
                            <div
                                    class="help is-danger"
                                    v-if="errors.has('bulk_number')"
                            >{{ errors.first('bulk_number') }}
                            </div>
                        </div>

                        <div v-else class="primary-input-container field input" style="position:relative;">
                            <p class="pimary-input-title">DNIS</p>
                            <input
                                    ref="recipientRef"
                                    list="recipient"
                                    name="recipient"
                                    class="pimary-input"
                                    v-model="dnis"
                                    v-validate="{required: true, numeric: true}"
                                    :class="{'input': true, 'is-danger': errors.has('recipient')}"
                            />
                            <datalist id="recipient">
                                <option v-for="(dn, idx) in dnis_list" :key="idx" :value="dn.phone_number"/>
                            </datalist>
                            <img
                                    style="pointer-events: none"
                                    src="/img/Down.b9194302.svg"
                                    alt class="icon-down datalist-img"/>
                            <div
                                    class="help is-danger"
                                    v-if="errors.has('recipient')"
                            >{{ errors.first('recipient') }}
                            </div>
                        </div>

                        <div v-if="!hideMessage" class="primary-input-container text-area mt-3">
                            <p class="pimary-input-title">message</p>
                            <div data-v-8e398240 class="text-area-container">
                <textarea
                        v-model="text"
                        v-validate="'required'"
                        :class="{'input': true, 'is-danger': errors.has('text')}"
                        name="text"
                        placeholder="Enter message content"
                        maxlength="160"
                        cols="30"
                        rows="10"
                ></textarea>
                            </div>
                            <div class="help is-danger" v-if="errors.has('text')">{{ errors.first('text') }}</div>
                        </div>

                        <div v-if="checked === 'Bulk'" class="primary-input-container mt-3">
                            <el-checkbox v-model="bulk_enable_random_text">Enable Random Text</el-checkbox>
                        </div>

                        <div class="primary-button mt-4">
                            <primary-button :disabled="loading"
                                            @click.native="fileUploadMode === 'Auto Substituting' ? sendSubstituting() : sendSms()">
                                Submit
                                <clip-loader
                                        style="width: 25px;"
                                        class="d-inline-block"
                                        v-if="loading"
                                        :loading="loading"
                                        color="#77bcff"
                                        size="16px"
                                ></clip-loader>
                            </primary-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ClipLoader from "vue-spinner/src/ClipLoader.vue";
    import TextArea from "../../../components/Inputs/TextArea";
    import axios from "axios";
    import XLSX from "xlsx";

    export default {
        name: "Index",
        components: {
            PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
            SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
            AppDropzone: () => import("@/components/Dropzone"),
            Loader: () => import("@/components/Loader.vue"),
            ClipLoader,
            TextArea,
            XLSX
        },
        data() {
            return {
                dnis_list: [],
                dnis: null,
                company_list: [],
                filtered_company_list: [],
                company: null,
                modelCompany: "",
                text: null,
                loading: false,
                checked: false,
                bulk_number: null,
                bulk_enable_random_text: false,
                file: null,
                fileinput: "",
                uploadNumbers: [],
                newNumberList: [],
                isShow: false,
                fileUploadMode: "Single Message",
                hideMessage: false,
                content: '',
                uploadedNumbers: [],
                fields_array: [],
                dynamicFieldsData: [],
                inputFileKey: 1
            };
        },
        watch: {
            fileUploadMode(val) {
                this.hideMessage = this.checked == "Import" && val === "Varying Message" || this.checked == "Import" && val === "Auto Substituting";
            },
        },
        methods: {
            getFields(e) {
                const that = this
                let val = e.target.value
                const regExp = /{([^}]+)}/g;
                const matches = val.match(regExp)
                console.log('matches', matches)

                if (matches && matches.length) {
                    this.fields_array = matches.map(e => {
                        return e.replace(/[{}]/g, "");
                    })
                    this.fields_array.forEach(fieldName => {
                        const check = that.dynamicFieldsData.find(e => e.fieldname === fieldName)
                    })
                }
            },
            closeSelect(e) {
                const inp = e.target.classList.contains("search-input");
                if (!inp) {
                    this.isShow = false;
                }
            },
            selectDid(e) {
                this.modelCompany = e.target.dataset.did;
                this.company = e.target.dataset.did;
                this.isShow = false;
            },
            showList(e) {
                e.stopPropagation()
                this.filtered_company_list = this.company_list;
                this.isShow = !this.isShow;
            },
            searchDid(e) {
                const val = this.modelCompany;
                if (e) {
                    this.company = e.target.value;
                }

                if (val === "") {
                    this.filtered_company_list = this.company_list;
                    return;
                }

                this.filtered_company_list = this.company_list.filter((did) => {
                    return did.did.indexOf(val) === 0;
                });
            },
            focusInput() {
                this.searchDid();
                this.isShow = true;
            },
            blurInput() {
                this.isShow = false;
            },
            onFileChange(e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length) return;
                this.file = files[0];
                this.createInput(this.file);
            },
            sendSubstituting() {
                console.log("uploadedNumbers:", this.uploadedNumbers)
                const form = {
                    text: this.content,
                    destinations: this.uploadedNumbers,
                    data: {}
                }
                const headers = {
                    'Content-type': 'application/json'
                }
                if (this.dynamicFieldsData.length) {
                    this.dynamicFieldsData.forEach(e => {
                        form.data[e.fieldname] = e.value
                    })
                }
                axios.post("/bulk_random", form, {
                    headers: headers
                }).then(res => {
                    this.$snotify.success("Success!");

                    this.content = '';
                    this.uploadedNumbers = [];
                    this.fields_array = [];
                    this.dynamicFieldsData = [];
                    this.inputFileKey++;
                    return res.data
                }).catch(res => {
                    this.$snotify.error("Failed!");
                    console.log('res', res);
                })
            },
            uploadNumbersFile(event) {
                this.uploadedNumbers = []
                this.file = event.target.files ? event.target.files[0] : null;
                if (this.file) {
                    const reader = new FileReader();

                    reader.onload = (e) => {
                        /* Parse data */
                        const bstr = e.target.result;
                        const wb = XLSX.read(bstr, {type: 'binary'});
                        /* Get first worksheet */
                        const wsname = wb.SheetNames[0];
                        const ws = wb.Sheets[wsname];
                        /* Convert array of arrays */
                        const data = XLSX.utils.sheet_to_json(ws, {header: 1});
                        this.uploadedNumbers.push(data.map(e => {
                            let el = e[0]
                            return el.toString()
                        }))
                        this.uploadedNumbers = this.uploadedNumbers[0]
                    }
                    reader.readAsBinaryString(this.file);
                }
            },
            uploadField(event, field) {
                this.file = event.target.files ? event.target.files[0] : null;
                if (this.file) {
                    const reader = new FileReader();

                    reader.onload = (e) => {
                        const bstr = e.target.result;
                        const wb = XLSX.read(bstr, {type: 'binary'});
                        const wsname = wb.SheetNames[0];
                        const ws = wb.Sheets[wsname];
                        const data = XLSX.utils.sheet_to_json(ws, {header: 1});
                        console.log('data', data)
                        var arr = []
                        arr.push(data.map(e => {
                            return e[0]
                        }))
                        const excelValue = arr[0].join()
                        this.dynamicFieldsData.push({fieldname: field, value: excelValue})
                    }
                    reader.readAsBinaryString(this.file);
                }
            },

            createInput(file) {
                let promise = new Promise((resolve, reject) => {
                    var reader = new FileReader();
                    var vm = this;
                    reader.onload = (e) => {
                        resolve((vm.fileinput = reader.result));
                    };
                    reader.readAsText(file);
                });

                promise.then(
                    (result) => {
                        if (this.fileUploadMode === "Single Message") {
                            this.bulk_number = null;
                            this.uploadNumbers = result.split(/\r?\n/);
                        }
                    },
                    (error) => {
                        console.log(error);
                    }
                );
            },
            showDnisList(e) {
                e.preventDefault();
                this.$refs.recipientRef.input();

            },
            async getCompanyList() {
                this.loading = true;
                const response = await this.$store.dispatch("GetAllDidsAni", {perPage: 100});
                this.company_list = response.items;
                this.filtered_company_list = response.items;
                this.loading = false;
            },
            async getDnisList() {
                const response = await this.$store.dispatch("GetRecipientListSmsCenter");
                this.dnis_list = response.items;
            },
            async sendSms() {
                const valid = await this.$validator.validate();
                if (!valid) return;
                this.loading = true;
                let data = {
                    text: this.text,
                    dnis: this.dnis,
                    ani: this.company,
                };

                // const isThere = this.company_list.find(
                //   (company) => company.did === this.company
                // );

                // if (!isThere) {
                //   this.$snotify.error("ANI is not found");
                //   this.loading = false;
                //   return;
                // }

                if (!this.company) {
                    delete data.ani;
                }

                let numbers = this.bulk_number
                    ? this.bulk_number.split(/\r?\n/).filter(Boolean)
                    : this.uploadNumbers.filter(Boolean);
                numbers.filter((number) => {
                    if (typeof number === "number") {
                        return number;
                    }
                });
                this.newNumberList = numbers;
                if (this.checked) {
                    data = {
                        text: this.text,
                        destinations: this.newNumberList,
                        checked: this.checked,
                        // type: this.bulk_number ? "bulk" : "import",
                        add_random_text: this.bulk_enable_random_text
                    };
                }
                if (this.fileUploadMode === "Varying Message") {
                    data.file = this.file;
                }

                const response = await this.$store.dispatch("SendSmsWorkflow", data);
                if (response.data && response.data.success) {
                    this.text = null;
                    this.dnis = null;
                    this.company = "";
                    this.modelCompany = "";
                    this.bulk_number = null;
                    this.uploadNumbers = [];
                    this.newNumberList = [];
                    this.checked = false;
                    this.bulk_enable_random_text = false;
                    this.$validator.reset();
                    this.$success("Success");
                } else if (response.response.data) {
                    if (response.response.data.error.hasOwnProperty("message")) {
                        try {
                            let messages = eval(response.response.data.error.message);

                            messages.map((message) => {
                                this.$snotify.error(message);
                            });
                        } catch (e) {
                            this.$snotify.error(response.response.data.error.message);
                        }
                    }
                }
                this.loading = false;
            },
        },
        created() {
            this.getCompanyList();
            this.getDnisList();
        },
    };
</script>

<style scoped>
    .help {
        margin-top: -2px;
        position: absolute;
    }

    .primary-button {
        height: 40px;
        width: 135px;
    }

    input::-webkit-calendar-picker-indicator {
        display: none;
    }

    .datalist-img {
        position: absolute;
        left: 100%;
        top: 25px;
        margin-left: -35px;
        background-color: white;
    }

    /* .primary-select-wrapper .icon-down {
      position: absolute;
      left: 100%;
      margin-left: -35px;
    } */
    .primary-select-wrapper select {
        -webkit-appearance: none;
        -moz-appearance: none;
        -ms-appearance: none;
        appearance: none;
        width: 100%;
        height: 100%;
        padding-left: 15px;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 25px;

    }

    .weekdays-from {
        margin-bottom: 15px;
    }

    .primary-select-wrapper {
        /* box-sizing: border-box; */
        /* position: relative; */
        /* display: flex; */
        /* align-items: center; */
        /* width: 100%; */
        height: 40px;
        /* border: 1px solid #edeef3; */
        /* border-radius: 4px; */
        /* background-color: #ffffff; */
    }

    .primary-input-container .text-area-container {
        position: relative;
        height: calc(100% - 20px);
        width: 100%;
    }

    .primary-input-container .pimary-input-title {
        color: #000000;
        font-family: "" Helvetica Neue "";
        font-size: 12px;
        font-weight: 300;
        letter-spacing: 0.21px;
        line-height: 15px;
        margin-bottom: 5px;
        text-transform: uppercase;
    }

    .searchable-dropdown {
        position: relative;
    }

    .searchable-dropdown .input {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 5;
        width: 100%;
    }

    .searchable-dropdown .input input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 40px;
        padding: 0 15px;
        border: 1px solid #edeef3;
        border-radius: 4px;
    }

    .searchable-dropdown .input img {
        position: absolute;
        top: 6px;
        right: 0;
        /* margin-left: -35px; */
        z-index: 10;
    }

    .primary-select-wrapper .inner-box {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 4;
        min-height: 32px;
        max-height: 205px;
        margin-top: 45px;
        /* padding: 45px 0 0; */
        background: white;
        box-shadow: 0px 2px 2px 0 #e0e0e0;
        overflow: auto;
        border: 1px solid #edeef3;
        border-radius: 5px;
    }

    .primary-select-wrapper .inner-box::-webkit-scrollbar {
        width: 4px;
        height: 0px;
        background: #fafafa;
    }

    .primary-select-wrapper .inner-box::-webkit-scrollbar-thumb {
        border-radius: 20px;
        background: #cacaca;
    }

    .primary-select-wrapper .inner-box div {
        width: 250px;
        padding: 5px 15px;
        cursor: pointer;
    }

    .primary-select-wrapper .inner-box div:hover {
        background: #f0f0f0;
    }

    .text-area {
        height: 120px;
        margin-bottom: 5px;
    }

    .primary-input-container .text-area-container textarea {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 10px 10px 10px 15px;
        border: 1px solid #edeef3;
        border-radius: 4px;
        outline: none;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 25px;
        resize: none;
    }

    .primary-input-container .pimary-input {
        width: 100%;
        height: 40px;
        border: 1px solid #edeef3;
        border-radius: 4px;
        background-color: #ffffff;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 25px;
        padding-left: 15px;
    }


    /*@media (max-width: 334px) {
      .radio_button_single{
        margin-left: 0px;
      }
    }*/
</style>

<style lang="scss" scoped>
    .container {
        position: relative;
        font-family: "Helvetica Neue";
        padding: 0 20px;
        display: flex;
        align-items: center;

        .add-navigation {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 40px;
            width: 100%;
            margin-top: 20px;
            margin-bottom: 20px;

            .back-link {
                cursor: pointer;
                display: flex;
                align-items: center;
                fill: #51a3f3;
                color: #51a3f3;
                font-family: "Helvetica Neue";
                font-size: 16px;
                font-weight: 500;
                line-height: 20px;

                p {
                    margin-bottom: 0;
                }
            }

            .buttons-wrapper {
                display: flex;
                align-items: center;
                width: fit-content;

                .primary-button {
                    height: 40px;
                    width: 110px;
                }

                .secondary-button {
                    height: 40px;
                    width: 90px;
                    margin-right: 20px;
                }
            }
        }

        .add-container {
            flex-direction: column;
            align-items: center;
            width: 100%;
            height: 100%;
            padding: 11px 0px 20px 0;

            .container-title {
                height: 30px;
                width: 432px;
                color: #000000;
                font-size: 16px;
                font-weight: 500;
                line-height: 30px;
                padding: 15px 0 15px 15px;
            }

            .col-wrapper {
                width: 100%;
                display: flex;
                justify-content: space-between;
                margin-top: 10px;
                background-color: white;

                .col {
                    width: 100%;

                    .input {
                        /*margin-bottom: 20px;*/
                    }

                    .field {
                        p.pimary-input-title {
                            color: #000000;
                            font-family: "Helvetica Neue";
                            font-size: 12px;
                            font-weight: 900;
                        }
                    }

                    .upload-photo,
                    #dropzone {
                        min-height: 285px;
                        min-height: 285px;
                        border-radius: 4px;
                        width: 100%;

                        .dz-image {
                            padding: 5px;

                            img {
                                height: 150px;
                                width: 150px;
                                border-radius: 50px;
                            }
                        }
                    }

                    p.pimary-input-title {
                        color: #000000;
                        font-family: "Helvetica Neue";
                        font-size: 12px;
                        font-weight: 900;
                    }

                    .upload-contaioner {
                        border: 1px solid #5171f3;
                        border-radius: 4px;
                        background-color: #ffffff;
                        height: 265px;
                        border-style: dashed;
                        margin-right: 15px;
                        position: relative;

                        input[type="file"] {
                            position: absolute;
                            height: 36px;
                            width: 136px;
                            opacity: 0;
                            cursor: pointer;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            -ms-transform: translate(-50%, -50%); /* IE 9 fix */
                            z-index: 1;
                        }

                        .upload-button {
                            height: 36px;
                            width: 136px;
                            border-radius: 4px;
                            background-color: #51a3f3;
                            margin: 0;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                        }
                    }
                }
            }

            .email-input {
                margin-bottom: 20px;
            }

            .password-input {
                margin-bottom: 30px;
            }

            .first {
                margin-bottom: 30px;

                .remember-me {
                    display: flex;
                    align-items: center;

                    input {
                        margin-right: 5px;
                    }
                }
            }
        }
    }

    .inner-box .item {
        padding: .9rem .8rem !important;
        border-bottom: 1px solid #edeef3;
        font-size: 12px;
        font-weight: 600;
    }
</style>
